<template>
  <div class="single-pane">
    <div class="slot-container">
      <slot></slot>
      <div class="p-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "single-pane"
};
</script>

<style lang="scss" scoped>
.single-pane {
  width: 100%;
  max-width: 100%;
}

.slot-container {
  padding: 25px 20px 10px 20px;
  height: 100%;
}
</style>
